(() => {
  if (window.nurCartFocusInstalled) return;
  window.nurCartFocusInstalled = true;

  const root = document.documentElement;
  const pointerInput = () => root.classList.add('nur-cart-pointer-input');
  const keyboardInput = () => root.classList.remove('nur-cart-pointer-input');

  if ('PointerEvent' in window) {
    document.addEventListener('pointerdown', pointerInput, true);
  } else {
    document.addEventListener('touchstart', pointerInput, { capture: true, passive: true });
    document.addEventListener('mousedown', pointerInput, true);
  }
  document.addEventListener('keydown', keyboardInput, true);
})();
